(function () {
    const section = document.querySelector('.review-cards');
    if (!section) return;

    const showAllTab = section.getAttribute('data-show-all-tab') === 'true';
    const tabs = section.querySelectorAll('.review-cards__tab');
    const wrapper = section.querySelector('.swiper-wrapper');
    const originalSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));

    let swiperInstance = null;
    let currentFilter = 'all';

    // Find initial active tab and color
    let activeTab = Array.from(tabs).find(t => t.classList.contains('active')) || tabs[0];
    if (activeTab) {
        currentFilter = activeTab.getAttribute('data-filter');
    } else if (!showAllTab && tabs.length > 0) {
        currentFilter = tabs[0].getAttribute('data-filter');
    }
    let currentColor = activeTab ? activeTab.getAttribute('data-color') : '#f9f497';

    function initReviewSwiper(SwiperConstructor) {
        const el = section.querySelector('.review-cards__grid');

        swiperInstance = new SwiperConstructor(el, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            centerInsufficientSlides: true,
            grabCursor: true,
            watchOverflow: true,
            breakpoints: {
                1000: {
                    spaceBetween: 32,
                }
            }
        });

        applyFilter();
        
        // Show content after Swiper is ready
        section.classList.add('swiper-ready');
    }

    function applyFilter() {
        if (!swiperInstance) return;

        // Apply background color to original elements first
        originalSlides.forEach(slide => {
            slide.style.backgroundColor = currentColor;
        });

        // Filter the slides based on category
        const filteredSlides = originalSlides.filter(slide => {
            const category = slide.getAttribute('data-category');
            // Only show 'all' if showAllTab is enabled
            return (showAllTab && currentFilter === 'all') || category === currentFilter;
        });

        // Use Swiper API to clear and add new valid slides
        swiperInstance.removeAllSlides();
        // Swiper appendSlide accepts an array of HTMLElement
        swiperInstance.appendSlide(filteredSlides);

        // Update swiper calculations (for centerInsufficientSlides, padding, bounds)
        swiperInstance.update();
        swiperInstance.slideTo(0, 0); // Reset to first slide on filter change
    }

    // Tab bindings
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');

            currentFilter = tab.getAttribute('data-filter');
            currentColor = tab.getAttribute('data-color');

            applyFilter();
        });
    });

    // Swiper Wait Logic (loads from theme's Swiper instance)
    function initWithRetry(retries) {
        if (retries <= 0) {
            console.warn('[ReviewCards] Swiper library not found.');
            return;
        }
        if (window.Swiper) {
            initReviewSwiper(window.Swiper);
        } else {
            setTimeout(() => initWithRetry(retries - 1), 100);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initWithRetry(40));
    } else {
        initWithRetry(40);
    }
})();
